<template>
    <div>
        <div class="verification-train" v-if="!status">
            <div class="banner">
                <img :src="banner" alt="" class="banner-img">
            </div>
            <div class="verification-form">
                <div class="input-item"><label class="item"><span>图虫昵称</span><input type="text" class="input"
                            placeholder="请输入图虫昵称" v-model="name" @blur.prevent="inputLoseFocus" /></label></div>
                <div class="input-item"><label>认证类别
                        <select class="select-css" @blur.prevent="inputLoseFocus" v-model="type">
                            <option v-for="(item, index) in verification_list" v-bind:key="index" value={{item}}>
                                {{ item }}</option>
                        </select>
                    </label></div>
                <div class="input-item"><label class="item"><span>接头暗号</span><input type="text" class="input"
                            placeholder="请输入接头暗号" v-model="key" @blur.prevent="inputLoseFocus" /></label></div>
            </div>
            <button class="submit" :disabled="!name || !type || !key" @click="submit()">提交</button>
        </div>
        <div class="success-page" v-else>
            <img class="icon"
                src="https://static-prod.ituchong.com/tc-common-fe-static/images/tuchong-webviews/6232244eaf5d66dfca646af41b71a302.png"
                alt="" />
            <p class="status">提交成功!</p>
            <p class="tip">工作人员会在 5 个工作日内完成审核,<br />审核结果将以图虫系统通知形式通知你！</p>
        </div>
        <tips ref="tips"></tips>
    </div>

</template>
<script>
import tips from './tips.vue'
import sniff from '../utils/sniff'
import { tuchongLog } from '../api/log'
import { postTrainInfo } from '../api/authentication.js'

export default {
    data() {
        return {
            status: 0, //1成功
            banner: window.banner,
            utm_source: window.utm_source,
            verification_list: window.verification_list,
            name: '',
            type: window.verification_list[0],
            key: ''
        }
    },
    components: {
        'tips': tips
    },
    mounted() {
        if(sniff.wechat) {
           this.weixinShare()
        }
        if(sniff.tuchong){
            JSBridge.setConfig({
                no_inset: 1,
                title: window.title
            });
        }   
    },
    methods: {
        apply() {
            location.href = '/app-authentication/instruction'
            tuchongLog({
                event_name: 'certification_click',
                event_time: new Date().toLocaleString(),
                params: JSON.stringify([{
                    click_position: 'enter_identity_detail',
                    user_id: window.visitorSite.site_id
                }])
            })
        },
        inputLoseFocus() {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 100);
        },
        submit() {
            postTrainInfo({
                name: this.name,
                vertical_type: this.type,
                password: this.key,
                utm_source: this.utm_source
            }, () => {
                this.status = 1
            }, (err) => {
                this.$refs.tips.tips(err.message, 3000)
            })
        },
        weixinShare() {
             wx.config({
                debug: false,
                appId: window.weixinConfig.app_id,
                timestamp: window.weixinConfig.timestamp,
                nonceStr: window.weixinConfig.nonce,
                signature: window.weixinConfig.signature,
                jsApiList:[
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ]
            })
             wx.ready(() => {
                const weixinShareObj = {
                    title: window.title,
                    link: window.location.href,
                    desc:  '点击认证',
                    imgUrl: "https://static-prod.ituchong.com/tc-common-fe-static/images/tuchong-webviews/bfe066d7e0152277214db0cc4c472eb3.png"
                }
                wx.onMenuShareTimeline(weixinShareObj);
                wx.onMenuShareAppMessage(weixinShareObj);
            })
        }
    }

}
</script>
<style lang="scss">
    html,body {
        height: 100%;
        overflow: hidden;
        background: #fff;
    }
    .verification-train {
        padding: .15rem;
        .banner {
            font-size: 0;
        }
        .banner-img {
            width: 100%;
            border-radius: .14rem;
        }
        .verification-form {
            margin-top: .18rem;
            color: #222;
            font-weight: lighter;
            font-size: 14px;
            .input-item {
                margin: .1rem 0;
                padding: .2rem 0 .2rem .2rem;
                border: 1px solid #EFEFEF;
                border-radius: 5px;
            }
            .item {
                display: flex;
                align-items: center;
            }
            .input {
                flex: 1;
                margin: 0 .18rem;
                border: none;
                outline: none;
                font-size: 14px;
            }
            .input::placeholder {
                font-size: 14px;
                color: #999;
            }
        }
        .submit {
            display: block;
            margin: .98rem auto 0;
            width: 2rem;
            height: .45rem;
            border: none;
            outline: none;
            border-radius: .24rem;
            color: #fff;
            font-size: 16px;
            background: linear-gradient(to left, rgb(245, 131, 101), rgb(255, 24,138));
            &:disabled{
                background: #CCCED0;
                color: #fff;
                border: none;
            }
        }
        .select-css::-ms-expand {
            display: none;
        }
        .select-css:focus {
            outline: none;
        }
        .select-css {
            margin-left: .18rem;
            width: 2.3rem;
            box-sizing: border-box;
            border: none;
            font-size: 14px;
            font-weight: bold;
            color: #222;
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;
            background: url('https://static-prod.ituchong.com/tc-common-fe-static/images/tuchong-webviews/a51216709e8f74887fd99cb022463df3.png') no-repeat right 0 top 50%, 0 0;
            background-size: .12rem auto, 100%;

        }
    }
    .success-page {
        text-align: center;
        .icon {
            margin-top: .86rem;
            width: 74px;
            height: 74px;
        }
        .status {
            margin-top: .11rem;
            color: #222;
            font-size: 14px;
            font-weight: bold;
        }
        .tip {
            margin: .26rem auto;
            color: #000;
            font-size: 12px;
        }
    }

</style>


